import { AlertDefinitionKey, CraneActionKey } from "./keys";

export type CraneAction = {
  id: CraneActionKey;
  name: string;
  description: string;
  relevantAlertDefinitions: AlertDefinitionKey[];
};

export const craneActions: Record<CraneActionKey, CraneAction> = {
  [CraneActionKey.HOISTING_UP]: {
    id: CraneActionKey.HOISTING_UP,
    name: "Hoisting",
    description: "Hoisting",
    relevantAlertDefinitions: [
      AlertDefinitionKey.MAIN_HOIST_OVERLOAD,
      AlertDefinitionKey.MAIN_HOIST_DRIVE_ERROR,
      AlertDefinitionKey.MAIN_HOIST_BRAKE_ERROR,
      AlertDefinitionKey.MAIN_HOIST_BLOCK_POSITION_HIGH,
    ],
  },
  [CraneActionKey.HOISTING_DOWN]: {
    id: CraneActionKey.HOISTING_DOWN,
    name: "Lowering",
    description: "Lowering",
    relevantAlertDefinitions: [
      AlertDefinitionKey.MAIN_HOIST_OVERLOAD,
      AlertDefinitionKey.MAIN_HOIST_DRIVE_ERROR,
      AlertDefinitionKey.MAIN_HOIST_BRAKE_ERROR,
    ],
  },
  [CraneActionKey.BOOMING_UP]: {
    id: CraneActionKey.BOOMING_UP,
    name: "Booming up",
    description: "Booming up",
    relevantAlertDefinitions: [
      AlertDefinitionKey.BOOM_HOIST_ANGLE_ERROR,
      AlertDefinitionKey.BOOM_HOIST_DRIVE_ERROR,
      AlertDefinitionKey.HIGH_WIND_SPEED,
    ],
  },
  [CraneActionKey.BOOMING_DOWN]: {
    id: CraneActionKey.BOOMING_DOWN,
    name: "Booming down",
    description: "Booming down",
    relevantAlertDefinitions: [
      AlertDefinitionKey.BOOM_HOIST_ANGLE_ERROR,
      AlertDefinitionKey.BOOM_HOIST_DRIVE_ERROR,
      AlertDefinitionKey.HIGH_WIND_SPEED,
    ],
  },
  [CraneActionKey.PERSONNEL_LIFT]: {
    id: CraneActionKey.PERSONNEL_LIFT,
    name: "Personnel lift",
    description: "Personnel lift",
    relevantAlertDefinitions: [
      AlertDefinitionKey.HIGH_WIND_SPEED,
      AlertDefinitionKey.MAIN_HOIST_BRAKE_ERROR,
      AlertDefinitionKey.MAIN_HOIST_DRIVE_ERROR,
    ],
  },
  [CraneActionKey.STOPPING]: {
    id: CraneActionKey.STOPPING,
    name: "Stopping",
    description: "Stopping",
    relevantAlertDefinitions: [
      AlertDefinitionKey.MAIN_HOIST_BRAKE_ERROR,
      AlertDefinitionKey.BOOM_HOIST_BRAKE_ERROR,
      AlertDefinitionKey.SLEWING_BRAKE_ERROR,
    ],
  },
  [CraneActionKey.STARTING]: {
    id: CraneActionKey.STARTING,
    name: "Starting",
    description: "Starting",
    relevantAlertDefinitions: [
      AlertDefinitionKey.MAIN_HOIST_DRIVE_ERROR,
      AlertDefinitionKey.BOOM_HOIST_DRIVE_ERROR,
      AlertDefinitionKey.SLEWING_DRIVE_ERROR,
    ],
  },
  [CraneActionKey.SLEWING_LEFT]: {
    id: CraneActionKey.SLEWING_LEFT,
    name: "Slewing left",
    description: "Slewing left",
    relevantAlertDefinitions: [
      AlertDefinitionKey.SLEWING_DRIVE_ERROR,
      AlertDefinitionKey.SLEWING_ANGLE_ERROR,
      AlertDefinitionKey.HIGH_WIND_SPEED,
    ],
  },
  [CraneActionKey.SLEWING_RIGHT]: {
    id: CraneActionKey.SLEWING_RIGHT,
    name: "Slewing right",
    description: "Slewing right",
    relevantAlertDefinitions: [
      AlertDefinitionKey.SLEWING_DRIVE_ERROR,
      AlertDefinitionKey.SLEWING_ANGLE_ERROR,
      AlertDefinitionKey.HIGH_WIND_SPEED,
    ],
  },
  [CraneActionKey.TUGGER_IN]: {
    id: CraneActionKey.TUGGER_IN,
    name: "Tugger in",
    description: "Tugger in",
    relevantAlertDefinitions: [
      AlertDefinitionKey.LOAD_TUGGER_11_ERROR,
      AlertDefinitionKey.LOAD_TUGGER_21_ERROR,
    ],
  },
  [CraneActionKey.TUGGER_OUT]: {
    id: CraneActionKey.TUGGER_OUT,
    name: "Tugger out",
    description: "Tugger out",
    relevantAlertDefinitions: [
      AlertDefinitionKey.LOAD_TUGGER_11_ERROR,
      AlertDefinitionKey.LOAD_TUGGER_21_ERROR,
    ],
  },
};

// Re-export for backward compatibility
export { CraneActionKey };
